import { render, staticRenderFns } from "./LayoutsWhatNotToDoSection.vue?vue&type=template&id=4503d151"
import script from "./LayoutsWhatNotToDoSection.vue?vue&type=script&lang=ts"
export * from "./LayoutsWhatNotToDoSection.vue?vue&type=script&lang=ts"
import style0 from "./LayoutsWhatNotToDoSection.vue?vue&type=style&index=0&id=4503d151&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports